export const REQUIRES_TWO_FACTOR = 'RequiresTwoFactor';
export const LOCKEDOUT = 'LockedOut';
export const FAILED = 'Failed';
export const ERROR_401 = 401;
export const CERTIFICATE_PIN_INCORRECT = 'CERTIFICATE_PIN_INCORRECT';
export const MAXIMUM_INCORRECT_CERTIFICATE_PIN_ATTEMPTS_REACHED =
  'MAXIMUM_INCORRECT_CERTIFICATE_PIN_ATTEMPTS_REACHED';
export const CERTIFICATE_EXPIRED = 'CERTIFICATE_EXPIRED';
